export class Timer {
    private _timer: number | null = null;
    private _interval: number | null = null;
    private readonly _duration: number = 5000;

    constructor(duration?: number) {
        if (duration) {
            this._duration = duration;
        }
    }

    public stop() {
        if (this._timer) {
            window.clearTimeout(this._timer);
            this._timer = null;
        }
        if (this._interval) {
            window.clearInterval(this._interval);
            this._interval = null;
        }
    }

    public initInterval(initFunction: Function, timeOut?: number) {
        this._timer = window.setTimeout(() => {
            initFunction();
            this._interval = window.setInterval(() => {
                initFunction();
            }, this._duration);
        }, timeOut || 0);
    }

    public initRequestInterval(request: () => Promise<void>, timeOut?: number) {
        const timer = window.setTimeout(async () => {
            try {
                await request();
            } finally {
                if (this._timer === timer) {
                    this.initRequestInterval(request, this._duration);
                }
            }
        }, timeOut || 0);
        this._timer = timer;
    }

    initTimeout(initFunction: Function, timeout: number) {
        this.stop();
        this._timer = window.setTimeout(() => {
            initFunction();
        }, timeout);
    }

    public get hasActualTimer() {
        return this._timer !== null;
    }
}
